export default "__VITE_ASSET__7eaf8498__"